export const ISHIKAWA_TEMPLATE_MIN_BONE_COUNT = 2;
export const ISHIKAWA_TEMPLATE_MAX_BONE_COUNT = 8;
export const ISHIKAWA_TEMPLATE_DEFAULT_BONE_ICON = 'label';

/** Default templates and their bones store translation keys as names; these are the key prefixes. */
export const ISHIKAWA_DEFAULT_TEMPLATE_LABEL_PREFIX = 'system.label.ishikawaTemplate';
export const ISHIKAWA_DEFAULT_BONE_LABEL_PREFIX = 'system.label.ishikawaBone';

/** Bone colours; a new bone takes the first one no other bone of the template uses. */
export const ISHIKAWA_BONE_COLORS: readonly string[] = [
  '#448aff',
  '#e0a100',
  '#8e5bd6',
  '#14a39a',
  '#e2577e',
  '#2fa84f',
  '#5b6ee1',
  '#ef5323',
];

/** Material icon ligatures offered for a bone; covers the icons of the seeded templates. */
export const ISHIKAWA_BONE_ICONS: readonly string[] = [
  'label',
  'engineering',
  'groups',
  'precision_manufacturing',
  'build',
  'description',
  'account_tree',
  'inventory_2',
  'science',
  'straighten',
  'speed',
  'eco',
  'thermostat',
  'local_shipping',
  'apartment',
  'settings_suggest',
  'school',
  'category',
  'sell',
  'place',
  'campaign',
  'fact_check',
  'trending_up',
  'schedule',
];
